// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-favorites[data-v-c997560a]{position:relative}.header-favorites__icon[data-v-c997560a]{height:21.6px;width:21.6px}@media (max-width:1023px){.header-favorites__icon[data-v-c997560a]{height:27px;width:27px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
